import { defineStore } from 'pinia';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import { useUrlsStore } from './urlsStore';
import { useProductsStore } from './productsStore';
import { useCategoriesStore } from './categoriesStore';
import { usePagesStore } from './pagesStore';
import { useScrapeControlStore } from '@/store/scrapeControlStore';
import Provider from '@/enums/Provider';

export const useActiveUrlStore = defineStore('activeUrl', {
  state: () => ({
    activeUrl: '' as string,
  }),
  getters: {
    // Change getter name and return type
    getProvider(): Provider {
      const urlSourcesStore = useUrlSourcesStore();
      return urlSourcesStore.getHomepageProvider ?? Provider.OTHER;
    },
  },
  actions: {
    setActiveUrl(url: string) {
      if (url !== this.activeUrl) {
        this.activeUrl = url;
        this.clearActiveStores();
        useScrapeControlStore().startFresh();
      }
    },
    clearActiveUrl() {
      this.setActiveUrl('');
    },
    clearActiveStores() {
      const siteUrlsStore = useUrlsStore();
      siteUrlsStore.clearUrlSourceStore();
      const urlsStore = useUrlsStore();
      urlsStore.clearUrlSourceStore();
      const productsStore = useProductsStore();
      productsStore.clearProductStore();
      const categoriesStore = useCategoriesStore();
      categoriesStore.clearCategoryStore();
      const pagesStore = usePagesStore();
      const urlSourcesStore = useUrlSourcesStore();
      urlSourcesStore.clearUrlSourceStore();
      pagesStore.clearPageStore();
    },
    getUrlByPathname(pathname: string): string {
      return `${this.activeUrl}${pathname}`;
    },
  },
});
